import { UnexpectedErrorComponent } from "@api/components/unexpected-error/unexpected-error.component";
import { SigninCallbackComponent } from "@auth/components/signin-callback.component";
import { SignoutCallbackComponent } from "@auth/components/signout-callback.component";
import { UnauthorizedComponent } from "@auth/components/unauthorized/unauthorized.component";
import { authUserGuard } from "@auth/guards/auth/auth-user/auth-user.guard";
import { CentersComponent } from "@centers/pages/centers.component";
import { AppLayoutComponent } from "@layout/components/layout/app.layout.component";
import { NotfoundComponent } from "@layout/components/notfound/notfound.component";
import { BEDSIDE_SHIFT_REPORT_URL_PATH } from "@shared/bedside-shift-report/constants";

export const routes = [
    {
        path: "",
        component: AppLayoutComponent,
        canActivate: [authUserGuard],
        children: [
            {
                path: "patient-details",
                loadChildren: () => import("./features/patient-details/routes").then((pd) => pd.routes),
            },
            {
                path: "encounter-details",
                loadChildren: () => import("./features/encounter-details/routes").then((ed) => ed.routes),
            },
            {
                path: "settings",
                loadChildren: () => import("./features/settings/routes").then((s) => s.routes),
            },
            {
                path: BEDSIDE_SHIFT_REPORT_URL_PATH,
                loadChildren: () => import("./features/bedside-shift-report/routes").then((b) => b.routes),
            },
        ],
    },
    { path: "signin-callback", component: SigninCallbackComponent },
    { path: "signout-callback", component: SignoutCallbackComponent },
    {
        path: "centers",
        component: CentersComponent,
        canActivate: [authUserGuard],
    },
    { path: "unauthorized", component: UnauthorizedComponent },
    { path: "unexpected-error", component: UnexpectedErrorComponent },
    { path: "**", component: NotfoundComponent },
];
